import { ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { TranslationService } from '@sdbn/common';
import { AttachDetachStepperModel } from '../../model/attach-detach-step-model';
import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { TransportAttachDetachStepperService } from '../../service/transport-attach-detach-stepper.service';

@Component({
  selector: 'app-detach-truck-and-trailer',
  templateUrl: './detach-truck-and-trailer.component.html',
  styleUrls: ['./detach-truck-and-trailer.component.scss']
})
export class DetachTruckAndTrailerComponent implements OnInit {

  stepperModel: AttachDetachStepperModel;

  @ViewChild('detachTruckAndTrailerForm', { static: true }) detachTruckAndTrailerForm: NgForm;

  constructor(
    public translationService: TranslationService,
    private stepperService: TransportAttachDetachStepperService
  ) {
    this.stepperModel = this.stepperService.stepperModel;

    // hook to enable/disable next button
    this.stepperModel.stepCompleted = () => {
      if (!this.detachTruckAndTrailerForm) {
        return false;
      }
      return this.detachTruckAndTrailerForm.valid;
    };

    this.stepperModel.getNextStepIndex = () => {
      return 0;
    };

    this.stepperModel.getPreviousStepIndex = () => {
      return 0;
    };

    this.stepperModel.beforeNextStep = () => {
      return true;
    };
  }

  ngOnInit() {
  }

}
